<script lang="ts">
  import { twMerge } from "tailwind-merge";
  import { Play } from "lucide-svelte";

  let { css = "", link = "/" }: { css?: string; link?: string } = $props();
</script>

<a href={link} class="group block">
  <div
    class={twMerge(
      "cursor-pointer rounded-lg bg-theme-green p-6 text-black transition group-hover:bg-theme-green-bright",
      css,
    )}
  >
    <div class="mb-3 text-2xl font-bold">Ask any question about this profile</div>

    <p class="mb-4 text-sm leading-snug text-zinc-900">Summarize, find key points, and more</p>

    <!-- Search Button -->
    <div class="mb-3">
      <span
        class="hover:bg-theme-accent-hover flex w-full cursor-pointer items-center justify-between gap-2 rounded-md bg-black px-4 py-2 text-lg text-sm font-medium text-white transition hover:scale-105 group-hover:scale-105"
      >
        Get started for free
        <Play size={16} />
      </span>
    </div>

    <!-- Footer -->
    <!-- <div class="text-xs text-zinc-800 text-center">
      100% Free • No Sign Up Required
    </div> -->
  </div>
</a>
